import React from 'react';
import { MapContainer, TileLayer, CircleMarker, Tooltip } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import Draggable from 'react-draggable';
import { useState } from 'react';

function Distribution({ data, countryWiseInvList }) {

  const [searchTerm, setSearchTerm] = useState('');

  const filteredCountries = countryWiseInvList?.filter((country) =>
    country?.city_name?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  console.log("filteredCountries", filteredCountries);

  if (!data || data.length === 0) return <p>No data available</p>;

  const minInv = Math.min(...data.map((c) => c.inv_count));
  const maxInv = Math.max(...data.map((c) => c.inv_count));

  return (
    <div style={{ position: 'fixed', height: '100vh', width: '100%' }}>
      <Draggable>
        <div style={{
          position: 'absolute',
          top: 90,
          left: 10,
          zIndex: 1000,
          background: '#FBF8FC',
          padding: '5px',
          border: '1px solid white',
          borderRadius: '8px',
        }}>
          <div className="card-body p-3">
            <input
              type="text"
              className="form-control mb-3"
              placeholder="Search country"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <div
              className="list-group p-2"
              style={{ maxHeight: '200px', overflowY: 'scroll' }}
            >
              {filteredCountries?.length > 0 ? (
                filteredCountries?.map((item, idx) => (
                  <div
                    key={idx}
                    className="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
                  >
                    {item.city_name}<span >{item.inv_count}</span>
                  </div>
                ))
              ) : (
                <div className="list-group-item text-muted">No matches</div>
              )}
            </div>
          </div>
        </div>
      </Draggable>

      <MapContainer
        style={{ height: '100%', width: '100%' }}
        zoom={4}
        center={[20.5937, 78.9629]}
        minZoom={2.5}
        maxZoom={10}
        scrollWheelZoom={true}
        maxBounds={[[-85, -180], [85, 180]]}
        maxBoundsViscosity={1.0}
      >
        <TileLayer
          url="https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png"
          attribution="&copy; <a href='https://carto.com/'>CARTO</a> contributors"
          tileSize={256}
        />
        {data.map((city, index) => {
          const relativeSize = (city.inv_count - minInv) / (maxInv - minInv);
          const radius = 5 + 15 * relativeSize;

          return (
            <CircleMarker
              key={index}
              center={[city.coordinates[0], city.coordinates[1]]}
              radius={radius}
              stroke={false}
              fillColor="#772396"
              fillOpacity={0.4}
            >
              <Tooltip direction="top" offset={[0, -5]} opacity={1} permanent={false} interactive={true} sticky={true}>
                <span>{`${city.city}: ${city.inv_count} Investors`}</span>
              </Tooltip>
            </CircleMarker>
          );
        })}
      </MapContainer>
    </div>
  );
}

export default Distribution;
